import DocFormModal from './DocFormModal';

export default DocFormModal;
